import React from 'react';

const QuotationMarkIconNavy = ({ ...props }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30 4V8.24561C27.8492 8.64327 26.1818 9.60234 24.9979 11.1228C23.814 12.6433 23.222 14.5848 23.222 16.9474V17.5789H26.8626C27.3756 18.1637 27.7505 18.8421 27.9873 19.614C28.2438 20.3626 28.3721 21.2164 28.3721 22.1754C28.3721 23.9766 27.9281 25.4035 27.0402 26.4561C26.1522 27.4854 24.9387 28 23.3996 28C21.5053 28 19.9958 27.2515 18.871 25.7544C17.766 24.2573 17.2135 22.2339 17.2135 19.6842C17.2135 15.5673 18.3975 12.0468 20.7653 9.12281C23.1529 6.19883 26.2311 4.49123 30 4ZM14.7865 4V8.24561C12.6357 8.66667 10.9782 9.64912 9.81395 11.193C8.64975 12.7135 8.06765 14.6784 8.06765 17.0877V17.5789H11.649C12.1621 18.1637 12.537 18.8421 12.7738 19.614C13.0303 20.3626 13.1586 21.2164 13.1586 22.1754C13.1586 23.9766 12.7146 25.4035 11.8266 26.4561C10.9387 27.4854 9.72516 28 8.18605 28C6.29175 28 4.78224 27.2515 3.65751 25.7544C2.5525 24.2573 2 22.2339 2 19.6842C2 15.5673 3.18393 12.0468 5.5518 9.12281C7.93939 6.19883 11.0176 4.49123 14.7865 4Z"
      fill="#003E7D"
    />
  </svg>
);

export default QuotationMarkIconNavy;
